import Ball from '@components/ball';
import { Flex } from '@phi/components/layout';
import { palette } from '@features/color-picker/state';
import { small_height } from '@phi/components';
import { rem } from '@phi/util/css';
import { PropType, defineComponent, h } from 'vue';

export const Palette = defineComponent({
    props: {
        value: {
            required: true,
            type: null as any as PropType<string | undefined>,
        },
    },

    emits: {
        'update:value': (x: string) => true,
    },

    computed: {
        trimmed_palette() {
            if (small_height())
                return palette.slice(0, 5);
            else
                return palette;
        },
    },

    render() {
        return h(Flex, {
            direction: 'row',
            wrap: true,
            gap: 'tight',
        }, () => this.trimmed_palette.map(x => h(Ball, {
            diameter: rem(2.4),
            color: x,
            inflates: true,
            inflated: x === this.value,
            onClick: () => this.$emit('update:value', x),
        })));
    },
});
